import { useEffect } from 'react';
import axiosInstance from '../lib/axios';

const useSiteMetadata = () => {
  useEffect(() => {
    const fetchAndApplySiteSettings = async () => {
      try {
        const response = await axiosInstance.get('/settings');
        const settings = response.data;
        
        // Update page title
        // Use site_title if set, otherwise fall back to site_name
        const title = settings.site_title || settings.site_name;
        if (title) {
          document.title = title;
        }
        
        // Update meta description
        if (settings.site_description) {
          let metaDescription = document.querySelector('meta[name="description"]');
          if (metaDescription) {
            metaDescription.setAttribute('content', settings.site_description);
          } else {
            metaDescription = document.createElement('meta');
            metaDescription.name = 'description';
            metaDescription.content = settings.site_description;
            document.head.appendChild(metaDescription);
          }
        }
        
        // Update favicon
        if (settings.site_favicon) {
          const faviconUrl = `${process.env.REACT_APP_BACKEND_URL}${settings.site_favicon}`;
          
          // Remove existing favicons
          const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
          existingFavicons.forEach(favicon => favicon.remove());
          
          // Add new favicon
          const link = document.createElement('link');
          link.rel = 'icon';
          link.type = 'image/png';
          link.href = faviconUrl;
          document.head.appendChild(link);
          
          // Add apple touch icon
          const appleTouchIcon = document.createElement('link');
          appleTouchIcon.rel = 'apple-touch-icon';
          appleTouchIcon.href = faviconUrl;
          document.head.appendChild(appleTouchIcon);
        }
      } catch (error) {
        console.error('Failed to fetch site settings for metadata:', error);
      }
    };
    
    fetchAndApplySiteSettings();
  }, []);
};

export default useSiteMetadata;
